// collection-infinite-scroll.js

(function() {
  function initInfiniteScroll() {
    const trigger = document.getElementById('infinite-scroll-trigger');
    const productGrid = document.getElementById('product-grid');
    if (!trigger || !productGrid) return;

    let nextUrl = trigger.getAttribute('data-next-url');
    let isLoading = false;

    // Use IntersectionObserver to detect when the trigger is close to entering the screen
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Pre-fetch next page when the trigger element comes within 400px of the viewport bottom
        if (entry.isIntersecting && !isLoading && nextUrl) {
          loadMoreProducts();
        }
      });
    }, {
      rootMargin: '0px 0px 400px 0px'
    });

    observer.observe(trigger);

    function loadMoreProducts() {
      isLoading = true;
      trigger.classList.add('loading');

      fetch(nextUrl)
        .then(response => response.text())
        .then(htmlText => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, 'text/html');

          // Append new products (resolving actual grid list container if it's a wrapper DIV)
          const actualGrid = productGrid.tagName === 'UL' ? productGrid : productGrid.querySelector('.product-grid');
          const fetchedGrid = doc.getElementById('product-grid');
          if (actualGrid && fetchedGrid) {
            const fetchedActualGrid = fetchedGrid.tagName === 'UL' ? fetchedGrid : fetchedGrid.querySelector('.product-grid');
            if (fetchedActualGrid) {
              const newProducts = fetchedActualGrid.querySelectorAll('.grid__item');
              newProducts.forEach(product => {
                actualGrid.appendChild(product);
              });
            }
          }

          // Check for next page trigger
          const newTrigger = doc.getElementById('infinite-scroll-trigger');
          if (newTrigger) {
            nextUrl = newTrigger.getAttribute('data-next-url');
            trigger.setAttribute('data-next-url', nextUrl);
          } else {
            nextUrl = null;
            trigger.remove(); // No more pages left
          }

          // Re-initialize event listeners for newly added product cards
          if (typeof window.initProductCards === 'function') {
            window.initProductCards();
          } else if (typeof initProductCards === 'function') {
            initProductCards();
          }

          // Trigger image lazy-load events
          document.dispatchEvent(new CustomEvent('lazyloaded'));
        })
        .catch(err => {
          console.error('Failed to load products on scroll:', err);
        })
        .finally(() => {
          isLoading = false;
          trigger.classList.remove('loading');
        });
    }
  }

  // Bind the scroll trigger logic
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initInfiniteScroll();
  } else {
    document.addEventListener('DOMContentLoaded', initInfiniteScroll);
  }

  // Shopify Customizer live updates integration
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initInfiniteScroll);
  }
})();
